import {
  RaGrid,
  RaGridItem,
  RaSkeletonLoader,
} from '@components/core/index.core'

export const RaFormSkeletonLoader = () => {
  const Field = (
    <RaSkeletonLoader
      width="100%"
      height="32px"
      margin="0"
    />
  )

  return (
    <RaGrid>
      <RaGridItem
        noMargin
        xs={4}
        sm={6}
        md={6}
        lg={6}>
        {Field}
      </RaGridItem>
      <RaGridItem
        noMargin
        xs={8}
        sm={6}
        md={6}
        lg={6}>
        {Field}
      </RaGridItem>
      <RaGridItem
        noMargin
        sm={12}
        md={12}
        lg={12}>
        {Field}
      </RaGridItem>
      <RaGridItem
        noMargin
        xs={6}
        sm={2}
        md={2}
        lg={2}>
        {Field}
      </RaGridItem>
      <RaGridItem
        noMargin
        xs={6}
        sm={5}
        md={5}
        lg={5}>
        {Field}
      </RaGridItem>
      <RaGridItem
        noMargin
        sm={5}
        md={5}
        lg={5}>
        {Field}
      </RaGridItem>
      <RaGridItem
        noMargin
        xs={4}
        sm={6}
        md={6}
        lg={6}>
        {Field}
      </RaGridItem>
      <RaGridItem
        noMargin
        xs={8}
        sm={6}
        md={6}
        lg={6}>
        {Field}
      </RaGridItem>
      <RaGridItem
        xs={6}
        sm={9}
        md={9}
        lg={9}>
        <div></div>
      </RaGridItem>
      <RaGridItem
        xs={6}
        sm={3}
        md={3}
        lg={3}>
        {Field}
      </RaGridItem>
    </RaGrid>
  )
}
